/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

export default class WondeRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return hash({
      connection: this.store
        .query('wonde/connection', {
          schoolId: this.session.activeSchool,
        })
        .then((connections) => {
          return connections[0];
        }),
    });
  }
}
